// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar {
    background-color: var(--templatesColorBackgroundContainer);
    border-radius: 5px;
    padding: 3px;
    animation: moveLeftGlobal 1s;
}

.ProgressBar > div {
    background-color: var(--templatesColorHeiglight);
    width: 40%;
    /* Adjust with JavaScript */
    height: 20px;
    border-radius: 5px;
    animation: progressBarProgress 1s;
}

.ProgressBarText {
    text-align: center;
    font-weight: 800;
    color: white;
    animation: moveRightGlobal 1s;
}

/* This is conntroled by a script */
@keyframes progressBarProgress {
    0% {
        width: 0%;

        /* Safari & Chrome */
        -webkit-width: 0%;

        /* Firefox */
        -moz-width: 0%;

        /* Internet Explorer */
        -ms-width: 0%;

        /* Opera */
        -o-width: 0%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueProgressBar/BlueProgressBar.css"],"names":[],"mappings":"AAAA;IACI,0DAA0D;IAC1D,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,gDAAgD;IAChD,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;AACjC;;AAEA,mCAAmC;AACnC;IACI;QACI,SAAS;;QAET,oBAAoB;QACpB,iBAAiB;;QAEjB,YAAY;QACZ,cAAc;;QAEd,sBAAsB;QACtB,aAAa;;QAEb,UAAU;QACV,YAAY;IAChB;AACJ","sourcesContent":[".ProgressBar {\n    background-color: var(--templatesColorBackgroundContainer);\n    border-radius: 5px;\n    padding: 3px;\n    animation: moveLeftGlobal 1s;\n}\n\n.ProgressBar > div {\n    background-color: var(--templatesColorHeiglight);\n    width: 40%;\n    /* Adjust with JavaScript */\n    height: 20px;\n    border-radius: 5px;\n    animation: progressBarProgress 1s;\n}\n\n.ProgressBarText {\n    text-align: center;\n    font-weight: 800;\n    color: white;\n    animation: moveRightGlobal 1s;\n}\n\n/* This is conntroled by a script */\n@keyframes progressBarProgress {\n    0% {\n        width: 0%;\n\n        /* Safari & Chrome */\n        -webkit-width: 0%;\n\n        /* Firefox */\n        -moz-width: 0%;\n\n        /* Internet Explorer */\n        -ms-width: 0%;\n\n        /* Opera */\n        -o-width: 0%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
